module.exports = __webpack_public_path__ + "assets/bg.0d5ec450.png";